import React from 'react';

import { Text } from '@actual-app/components/text';
import { theme } from '@actual-app/components/theme';
import { View } from '@actual-app/components/view';

type Props = {
  titulo: string;
  /** Vão extra acima — usado a partir do segundo grupo, pra separar sem régua. */
  primeiro?: boolean;
};

/**
 * Cabeçalho de um grupo do menu ("MEU MÊS", "MEU DINHEIRO").
 *
 * Separa os grupos só por ESPAÇO e por contraste de peso/cor, nunca por uma
 * régua horizontal — mesma regra nº 1 que vale nas telas (ver o JSDoc de
 * `finapp/estilo.ts`): borda repetida vira malha, e malha lê-se como aperto.
 *
 * ⚠️ Usa os tokens de tema do Actual (`theme.sidebarItemText`), não os tokens
 * `cor.*` das nossas telas: a barra lateral é escura e pertence ao tema, então
 * um hex fixo daqui ficaria ilegível se o tema mudar.
 */
export function CabecalhoGrupo({ titulo, primeiro = false }: Props) {
  return (
    <View
      style={{
        flexShrink: 0,
        paddingLeft: 19,
        paddingRight: 10,
        marginTop: primeiro ? 8 : 20,
        marginBottom: 4,
      }}
    >
      <Text
        style={{
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: '.09em',
          textTransform: 'uppercase',
          color: theme.sidebarItemText,
          opacity: 0.65,
        }}
      >
        {titulo}
      </Text>
    </View>
  );
}
